import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import { CLINIC, PAGES } from "../lib/clinic";

export const Footer = () => {
  return (
    <footer className="bg-brand-navyDark text-stone-300" data-testid="footer">
      <div className="container-x pt-24 pb-12">
        <div className="grid md:grid-cols-12 gap-14">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-4 mb-6">
              <span className="inline-flex items-center justify-center w-12 h-12 border border-white/30">
                <span className="heading-serif text-white text-[20px] font-semibold leading-none">
                  AD
                </span>
              </span>
              <div>
                <div className="heading-serif text-2xl text-white font-semibold">
                  Dr. Avril Dhar
                </div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-brand-gold mt-1">
                  Neurologist · Psychologist
                </div>
              </div>
            </div>
            <p className="text-stone-400 leading-relaxed mb-7 max-w-sm text-[15px]">
              Advanced neurology and mental wellness care with a compassionate,
              patient-focused approach in the heart of Chandigarh.
            </p>
            <a
              href={CLINIC.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 border border-white/30 text-white px-6 py-3 hover:bg-white hover:text-brand-navyDark transition-all text-[12px] tracking-[0.06em] uppercase font-medium"
              data-testid="footer-whatsapp-cta"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp Us
            </a>
          </div>

          {/* Pages */}
          <div className="md:col-span-2">
            <h4 className="text-white font-medium mb-5 text-[11px] uppercase tracking-[0.28em]">
              Pages
            </h4>
            <ul className="space-y-3 text-[14px]">
              {PAGES.map((p) => (
                <li key={p.path}>
                  <Link
                    to={p.path}
                    className="hover:text-brand-gold transition-colors"
                    data-testid={`footer-link-${p.label.toLowerCase()}`}
                  >
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="text-white font-medium mb-5 text-[11px] uppercase tracking-[0.28em]">
              Services
            </h4>
            <ul className="space-y-3 text-[14px] text-stone-400">
              <li>Headache & Migraine</li>
              <li>Stroke Care</li>
              <li>Parkinson's Disease</li>
              <li>Memory Problems</li>
              <li>Anxiety & Depression</li>
              <li>Stress Management</li>
              <li>Online Consultation</li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-white font-medium mb-5 text-[11px] uppercase tracking-[0.28em]">
              Get in touch
            </h4>
            <ul className="space-y-4 text-[14px]">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-brand-gold" />
                <a
                  href={`tel:${CLINIC.phoneRaw}`}
                  className="hover:text-white"
                  data-testid="footer-phone"
                >
                  {CLINIC.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-brand-gold" />
                <a
                  href={`mailto:${CLINIC.email}`}
                  className="hover:text-white break-all"
                  data-testid="footer-email"
                >
                  {CLINIC.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-brand-gold" />
                <span>{CLINIC.location}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-brand-gold" />
                <div>
                  {CLINIC.hours.map((h, i) => (
                    <div key={i} className="text-stone-400 text-[13px]">
                      <span className="text-stone-200">{h.day}</span> · {h.time}
                    </div>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-[11px] tracking-wide text-stone-500">
          <p>© {new Date().getFullYear()} Dr. Avril Dhar. All rights reserved.</p>
          <p className="tracking-[0.2em] uppercase text-stone-400">
            Better Brain · Better Mind · Better Life
          </p>
        </div>
      </div>
    </footer>
  );
};
